import { getRandomUniqueColor } from "./format-utils";
import {
  CONSTANTS,
  GRAPH_TYPES,
  REPORT_TYPES,
  VERTICALS,
} from "../../../constants/app-constant";
const {
  PIE,
  BAR_HORIZONTAL,
  BAR_VERTICAL,
  BAR_STACKED,
  AREA,
  LINE,
  TABLE,
  WORD_CLOUD,
  GENDER,
} = GRAPH_TYPES;
const {
  REPORTS: { TYPES },
} = CONSTANTS;
export const formatDataByCCM = (
  d = [],
  graph_type,
  isLineGraph,
  type,
  report_type
) => {
  try {
    const reportType = TYPES.filter((t) => t.id == report_type)[0];
    const {
      graphDataType: { print, online },
      groupByField,
      countKey,
    } = reportType;
    const rType = type === VERTICALS.V_PRINT ? print : online;
    let data = d[rType] && d[rType].returnData;
    const graphColors = getRandomUniqueColor(data.length);
    let labels = [];
    let BGcolors = [];
    let tempData = [];
    data.forEach((elm, index) => {
      labels.push(elm.entity);
      BGcolors.push(graphColors[index]);
      tempData.push(elm[countKey]);
    });
    const datasets = [
      {
        label: "SOV CCM",
        backgroundColor: BGcolors,
        borderColor: BGcolors,
        borderWidth: 1,
        data: tempData,
        barThickness: "flex",
        fill: graph_type === AREA ? "start" : false,
        lineTension: 0,
      },
    ];
    return {
      labels,
      datasets,
    };
  } catch (e) {
    return {
      labels: [],
      datasets: [],
    };
  }
};
